import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useStaffAuth } from './StaffAuthContext';
import { currentStaffAdminPath, staffAdminReturnState } from './staffAdminReturnPath';

function StaffSessionLoading() {
  return (
    <div style={{ minHeight: '100vh', background: '#080B12', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#e8edf4' }} role="status">
      Loading staff session…
    </div>
  );
}

export default function StaffAdminRouteGuard({ children }) {
  const { staffUser, loading } = useStaffAuth();
  const location = useLocation();

  if (loading) return <StaffSessionLoading />;
  if (!staffUser) {
    const returnTo = currentStaffAdminPath(location);
    return <Navigate to="/admin/login" replace state={staffAdminReturnState(returnTo)} />;
  }
  return children;
}

export function StaffAdminNamespaceFallback() {
  const { staffUser, loading } = useStaffAuth();
  const location = useLocation();

  if (loading) return <StaffSessionLoading />;
  if (!staffUser) {
    const returnTo = currentStaffAdminPath(location);
    return <Navigate to="/admin/login" replace state={staffAdminReturnState(returnTo)} />;
  }
  return <Navigate to="/admin/dashboard" replace />;
}